import styled from 'styled-components'
import { DEVICE } from '../../../util/constants'
import { GriddedContentBlock } from '../../styles/Utility.styles'

export const AccordionBlock = styled(GriddedContentBlock)`
  /* Naming Convenience */
  margin-top: 0;
`

export const SectionHeader = styled.h2`
  grid-column: 2 / 12;
  margin-bottom: 14px;
  text-transform: uppercase;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 1.4rem;
  letter-spacing: 0.02em;
  color: var(--content-background-dark-blue);

  @media ${DEVICE.tabletL} {
    font-size: 1.8rem;
  }

  [data-layout='two-column'] & {
    @media ${DEVICE.laptopG} {
      grid-column: span 12;
    }
  }
`

export const AccordionRow = styled.div`
  grid-column: 2 / 12;
  display: grid;
  grid-template-columns: repeat(8, 1fr) 0.5fr 0.5fr 1fr;
  margin-top: 12px;

  @media ${DEVICE.tabletL} {
    grid-template-columns: repeat(10, 1fr);
    font-size: 1.8rem;
  }

  [data-layout='two-column'] & {
    @media ${DEVICE.laptopG} {
      grid-column: span 12;
    }
  }
`

export const ExpandableContentBlock = styled.div`
  grid-column: 2 / 11;
  background-color: var(--content-background-light);
`

export const BlockHeader = styled.h3`
  user-select: none;
  font-size: 1.8rem;
  line-height: 1.5;
  color: var(--highlight-blue);
  padding: 11px 10px 11px 16px;
  text-decoration-line: ${({ isOpen }) => (isOpen ? 'underline' : 'unset')};

  @media ${DEVICE.tabletL} {
    font-size: 2.4rem;
    padding: 28px 40px 28px 31px;
  }

  @media ${DEVICE.laptopS} {
    font-size: 2.8rem;
  }
`

export const BlockCopy = styled.div`
  font-size: 1.6rem;
  line-height: 1.6;
  color: var(--content-background-dark-blue);
  padding: 0 16px;
  height: ${({ contentHeight }) => contentHeight}px;
  overflow: hidden;
  transition: height 0.25s ease-out, padding 0.25s ease-out;

  p {
    padding-bottom: 1rem;

    :last-of-type {
      padding-bottom: 2rem;
    }
  }

  a {
    color: var(--content-background-dark-blue);
  }

  ul {
    list-style-type: disc;
  }

  ul,
  ol {
    margin-left: 2rem;
  }

  li {
    padding-bottom: 1rem;

    :last-of-type {
      padding-bottom: 2rem;
    }
  }

  @media ${DEVICE.tabletL} {
    font-size: 1.8rem;
    line-height: 1.6;
    padding: 0 40px 0 31px;
  }
`

export const AccordionArrow = styled.svg`
  grid-column: 1;
  margin-top: 12px;
  justify-self: flex-start;
  width: 32px;
  height: 32px;

  @media ${DEVICE.tabletL} {
    display: flex;
    justify-self: center;
    margin-top: 36px;
    width: 45px;
    height: 45px;
  }
`
